export function useGoogleBusinessInformation() {
  const data = useState('googleBusinessInformation', () => null as null | any)
  const loading = useState('googleBusinessInformationLoading', () => false)

  const load = () => {
    if (!data.value && !loading.value) {
      loading.value = true
      useGraphqlQuery('googleBusinessInformationToday', {}, useGraphqlDefaultClient()).then((response) => {
        loading.value = false
        data.value = response.data?.googleBusinessInformation || null
      })
    }
  }

  const loadDetails = async (id: string) => {
    const response = await useAsyncGraphqlQuery('googleBusinessInformation', { ids: [id] }, useGraphqlDefaultClient())
    return response?.data.value?.data?.googleBusinessInformation?.[0] || null
  }

  return {
    load,
    data,
    loadDetails,
  }
}
